'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './custom-entity-edit.routes';

export class CustomEntityEditComponent {
  constructor(SettingsService, Auth, $state, dialogs) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.active = 0;

    this.sortableOptions = {
      handle: '.handle'
    };

    this.SettingsService.getByName({name: 'custom-entities'}, customEntitiesSettings => {
      this.settings = customEntitiesSettings;
      this.model = customEntitiesSettings.data;
      /*
      this.entities = customEntitiesSettings.data.entities;
      this.entityListTabs = customEntitiesSettings.data.entityListTabs;
      this.entityList = customEntitiesSettings.data.entityList;
      this.entityView = customEntitiesSettings.data.entityView;
      this.entitySchema = customEntitiesSettings.data.entitySchema;

       */
    });
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The custom entity settings have been changed successfully");
        dlg.result.then(() => {
          that.$state.go("home");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

//      this.settings.data = this.model;

      this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.customEntityEdit', [uiRouter])
  .config(routes)
  .component('customEntityEdit', {
    template: require('./custom-entity-edit.html'),
    controller: CustomEntityEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/custom-entity-edit/custom-entity-edit.component.js